import { type CSSProperties, type FC } from "react";
import { Tag, TagIntent } from "widgets";

import type { OrganismTagFragment } from "@/modules/saved-items/graphql/saved-items.gql.ts";

interface OrganismTagProps {
  organism: OrganismTagFragment;
  style?: CSSProperties;
}

const OrganismTag: FC<OrganismTagProps> = (props) => {
  return (
    <Tag
      key={props.organism.id}
      intentColor={TagIntent.Secondary}
      data-testid={"organism"}
      label={
        <span>
          {props.organism.name}, <i>{props.organism.species?.name}</i>
        </span>
      }
      style={props.style}
    />
  );
};

export { OrganismTag };
